import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "mleft-10" }
const _hoisted_3 = { class: "mtop-15 row gap-10" }

import { onMounted } from 'vue';
import appuserapi from '@/api/appuserapi';
import { createReferenceSheetTitle } from '@/functions/resultSuggestion.js';
import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'editRefSheet',
  props: {
  refSheet: {
    type: Object,
    required: true,
  },  
},
  emits: ['updateClose', 'update'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props

const emits = __emit;

async function deleteRefSheet() {
  console.log("deleteRefSheet");
  const appUserResultReferenceId = props.refSheet.appUserResultReferenceId;
  await appuserapi.deleteRefSheet(appUserResultReferenceId);
  emits ('updateClose');
}

onMounted(() => {
  console.log(props.refSheet);
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"22rem"},
    class: "bg-modal",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(createReferenceSheetTitle)(props.refSheet),
        styles: "font-l"
      }, null, 8, ["txt"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_button_group, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteRefSheet()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "trash",
              styles: "main-m size-m"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_button_group, {
        styles: "pad-s border-l",
        style: {"padding-left":"0.4rem","padding-right":"0.4rem"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _unref(t)('action.import'),
            styles: "font-mBold main-m",
            class: "mleft-03"
          }, null, 8, ["txt"])
        ]),
        _: 1
      }),
      _createVNode(_component_button_group, {
        styles: "pad-s border-l",
        style: {"padding-left":"0.4rem","padding-right":"0.4rem"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _unref(t)('action.synchronize'),
            styles: "font-mBold main-m",
            class: "mleft-03"
          }, null, 8, ["txt"])
        ]),
        _: 1
      }),
      _createVNode(_component_button_group, {
        styles: "pad-s border-l",
        style: {"padding-left":"0.4rem","padding-right":"0.4rem"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: _unref(t)('action.share'),
            styles: "font-mBold main-m",
            class: "mleft-03"
          }, null, 8, ["txt"])
        ]),
        _: 1
      })
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mtop-06" }, null, -1))
  ]))
}
}

})